import React from 'react';

const HowItWorks = ({ onNavigate }) => {
  return (
    <div className="min-h-screen bg-[#00162C] text-white pt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            How it works
          </h1>
          <h2 className="text-2xl md:text-3xl font-medium bg-gradient-to-r from-[#0AB1B5] via-[#6DC066] to-[#7DF1EC] bg-clip-text text-transparent mb-6">
            The secret weapon for business owners
          </h2>
          <p className="text-lg text-gray-300 max-w-4xl mx-auto">
            No time to scour your contract for hidden fees and junk charges? No problem. RateIQ instantly analyzes your credit card statement to <strong className="text-white">find out what your payment processor is hiding.</strong>
          </p>
        </div>

        {/* How It Works GIF */}
        <div className="mb-16 text-center">
          <div className="bg-white/5 backdrop-blur-sm border border-white/20 rounded-lg p-8 mb-8 max-w-4xl mx-auto">
            <img 
              src="/how-it-works.gif" 
              alt="How RateIQ works demonstration"
              className="max-w-full h-auto rounded-lg"
            />
          </div>
        </div>

        <div className="max-w-4xl mx-auto space-y-16">
          {/* Step 1: Upload */}
          <div className="text-center">
            <h2 className="text-3xl font-medium text-white mb-6">
              Step 1: Upload
            </h2>
            <p className="text-lg text-gray-300">
              RateIQ eats processing statements for breakfast. Feed it a credit card processing statement of your choice by selecting one from your file browser or dragging it into the box.
            </p>
          </div>

          {/* Step 2: Analyze */}
          <div className="text-center">
            <h2 className="text-3xl font-medium text-white mb-6">
              Step 2: Analyze
            </h2>
            <p className="text-lg text-gray-300">
              Our AI algorithm decodes your statement, extracts the most relevant info, and spits out all the junk. Watch a short ad while you wait for the results.
            </p>
          </div>

          {/* Step 3: Expose */}
          <div className="text-center">
            <h2 className="text-3xl font-medium text-white mb-6">
              Step 3: Expose
            </h2>
            <p className="text-lg text-gray-300 mb-8">
              The tool shows you the results of its work: a simple, straightforward breakdown of the fees you're paying, including hidden junk fees, and a calculation of what you could potentially save by switching to a different vendor.
            </p>

            <h3 className="text-2xl font-medium text-white mb-4">
              What's next?
            </h3>
            <p className="text-lg text-gray-300">
              That's up to you, but we hope you'll annoy payment processors with your new intel. Use it to renegotiate, find a new vendor, or keep it in your back pocket while you make plans for all the money you're about to save.
            </p>
          </div>
        </div>

        {/* FAQs Section */}
        <div className="mt-24 max-w-4xl mx-auto">
          <h2 className="text-3xl font-medium text-white mb-12 text-center">
            FAQs
          </h2>
          
          <div className="space-y-8">
            <div>
              <h3 className="text-xl font-medium text-white mb-4">
                Seems pretty convenient. What's the catch?
              </h3>
              <p className="text-gray-300">
                Nothing crazy - just watch a (30 second) ad while RateIQ works its magic. This helps cover costs to keep our tool operational. Besides, we figure it's still faster than reading through a long contract crammed with legal jargon.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-medium text-white mb-4">
                Why did you make this tool?
              </h3>
              <p className="text-gray-300">
                Because we're tired of seeing small business owners get screwed over by the big dogs. With all the fluff they put in those contracts – knowing you don't have the time or legal expertise to fully understand what's inside – payment processors think they have all the leverage. We're here to prove them wrong.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-medium text-white mb-4">
                Are you an alternative payment processor?
              </h3>
              <p className="text-gray-300">
                Nope, we're just here to provide a tool to understand how much you're overpaying and how much you can save. Once you're ready to negotiate your rates or find a new processor, the data from RateIQ will be the ace in your sleeve.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-medium text-white mb-4">
                How does the tool work?
              </h3>
              <p className="text-gray-300">
                Our marketing people don't understand programming, but we can tell you it's powered by AI and designed specifically for one purpose: to help business owners decode their credit card processing statements and reveal their potential savings.
              </p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="mt-24 text-center">
          <h2 className="text-3xl font-medium text-white mb-6">
            Ready to get started?
          </h2>
          <p className="text-lg text-gray-300 mb-8">
            It's free and shows you potential savings in less than a minute.
          </p>
          <button
            onClick={() => onNavigate('home')}
            className="bg-[#DBE46D] hover:bg-[#DBE46D]/90 text-gray-900 font-medium py-3 px-8 rounded-lg transition-colors duration-200"
          >
            Decode my statement
          </button>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks; 